import { render, staticRenderFns } from "./PatentsList.vue?vue&type=template&id=4039a697"
import script from "./PatentsList.vue?vue&type=script&lang=js"
export * from "./PatentsList.vue?vue&type=script&lang=js"
import style0 from "./patents-list.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports